import { render, staticRenderFns } from "./Input-AccountId.vue?vue&type=template&id=5733895a&lang=pug"
import script from "./Input-AccountId.vue?vue&type=script&lang=ts"
export * from "./Input-AccountId.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports